<template>
  <div class="bg-container page"  :style="{'background-image':`url(${$store.getters.getBaseInfo.login_bg})`}">
    <!-- <img class="bg-img" v-if="$store.getters.getBaseInfo.login_bg" :src="$store.getters.getBaseInfo.login_bg" /> -->
    <div>
      <div class="register">
        <van-nav-bar class="nav-bar" style="background:none;color: #333333;" :title="$t('auth.register')">
          <template #left>
            <van-icon name="arrow-left" color="#333333" @click="back()" />
          </template>
        </van-nav-bar>
        <div class="wrapper">
          <div class="logo-container">
            <div class="logo-wrapper" style="opacity: 0;">
              <img class="logo-img"
                :src="this.$store.getters.getBaseInfo.ico !== undefined ? this.$store.getters.getBaseInfo.ico : ''">
            </div>
          </div>
          <!-- <div class="title">{{$t("auth.register")}}</div> -->
          <div class="loginForm">
            <van-field v-model="username"  @input="trimSpace"  style="color: #ffffff;" clearable class="input" :placeholder="$t('auth.username_place')">

              <template #left-icon>
                <div style="height:100%; display: flex;justify-content: center;align-items: center;">
                  <img style="width: 20px;" src="/img/login/phone.png?t=2" alt="">
                </div>
              </template>
            </van-field>
            <van-field v-model="password" :type="passwordType" class="input" :placeholder="$t('auth.pwd_place')">

              <template #left-icon>
                <div style="height:100%; display: flex;justify-content: center;align-items: center;">
                  <img style="width: 20px;" src="/img/login/psw.png?t=2" alt="">
                </div>
              </template>
              <template slot="right-icon">
                <van-icon
                color="#ffffff" :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'" @click="switchPasswordType" />
              </template>
            </van-field>
            <van-field v-model="code" clearable class="input" :placeholder="$t('auth.invite_code_place')">

              <template #left-icon>
                <div style="height:100%; display: flex;justify-content: center;align-items: center;">
                  <img style="width: 20px;" src="/img/login/code.png?t=2" alt="">
                </div>
              </template>
            </van-field>
            <!-- <div class="agreement">
              <van-checkbox v-model="checked" />
              <span class="agreement-text">{{$t("auth.agreement_place")}}</span>
            </div> -->
            <van-button class="login-btn" :disabled="isDisabled" type="primary" size="normal"
              @click="doRegister()">{{ $t("auth.register") }}</van-button>
            <van-button class="login-btn-log" :disabled="isDisabled" type="primary" size="normal"
              @click="back()">{{ $t("auth.login") }}</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      lang: '',
      password: this.inputValue,
      passwordType: 'password',
      isDisabled: false
    };
  },
  mounted() {
    this.lang = localStorage.getItem("viodeLang") || this.$store.state.langDefault;
  },
  methods: {
    trimSpace(e) {
      // 移除所有空格
      this.username =e.replace(/\s/g, '')
      // 或者只移除首尾空格：this.username = e.target.value.trim()
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back() {
      return window.history.back();
    },
    doRegister() {
      if (this.username === "" || this.username === null || this.username === undefined) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if (this.password === "" || this.password === null || this.password === undefined) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if (this.code === "" || this.code === null || this.code === undefined) {
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if (!this.checked) {
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.isDisabled = true
      this.$http({
        method: 'post',
        data: {
          username: this.username,
          password: this.password,
          code: this.code,
          lang: this.lang
        },
        url: 'member_register'
      }).then(res => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("tokensso", res.data.tokensso);
          localStorage.setItem('token', res.data.id)
          this.$router.push("Mine")
        } else {
          this.$toast.fail(res.msg);
        }
        this.isDisabled = false
      })
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.register {
  height: 100%;
}

.bg-container{
  background-repeat: no-repeat;
  background-size: 100% 100%;

}
.bg-container .bg-wrapper .register .nav-bar {
  background: 0 0
}

.register .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.logo-container {
  margin: 0 auto;
  width: 60%;
}

.logo-container .logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}

.logo-container .logo-wrapper .logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
  opacity: 0.8;
}

.register .wrapper .title {
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 5px;
}

.register .wrapper .loginForm {
  padding: 30px;
}

.register .wrapper .loginForm .input {
  width: 80%;
  margin: auto;
  padding: 10px 20px;
  margin-top: 35px;
  border-radius: 10px;
  text-align: center;
  line-height: 70px;
  font-size: 30px;
  background: none;
  border: 1px solid #333333;
  color: #333333;
}

::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}

::v-deep .van-icon {
  font-size: 50px;
}

.register .wrapper .loginForm .reset-text {
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.register .wrapper .loginForm .reset-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
}

.register .wrapper .loginForm .register-text {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.register .wrapper .loginForm .register-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}

.register .wrapper .loginForm .login-btn {
  margin: 0 auto;
  width: 200px;
  display: block;
  margin-top: 30px;
  height: 80px;
  border-radius: 50px;
  background: linear-gradient(90deg, #3882b0, #a8197a, #541349, #541950, #541851);
  font-size: 30px;
  font-weight: bolder;
  border: none;
  margin-top: 60px;
  opacity: 0.8;
}

.login-btn-log {
  margin: 0 auto;
  width: 200px;
  display: block;
  margin-top: 30px;
  height: 80px;
  border-radius: 50px;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  margin-top: 40px;
  position: relative;
  background: none;
  color: #004aad;
  opacity: 0.8;
}

.login-btn-log::before {
  content: "";
  position: absolute;
  top: -6px;
  bottom: -6px;
  left: -6px;
  right: -6px;
  background: linear-gradient(90deg, #3882b0, #a8197a, #541349, #541950, #541851);
  border-radius: 54px;
  z-index: -2;
  transform: none;
  width: auto;
  height: auto;
  opacity: 1;
}

.login-btn-log::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  border-radius: 54px;
  z-index: -1;
}

.register .wrapper .loginForm .agreement {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.register .wrapper .loginForm .agreement .agreement-text {
  margin-left: 10px;
  font-size: 25px;
  color: #fff;
  font-weight: 500;
  line-height: 30px;
}

::v-deep .agreement .van-icon {
  font-size: 30px;
}

::v-deep .agreement .van-checkbox__icon {
  font-size: 38px;
}

::v-deep .agreement .van-checkbox__icon--checked .van-icon {
  color: #fff;
  border-color: rgb(126, 86, 120);
  background-color: rgb(126, 86, 120);
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #ffffff;
  font-size: 35px;
}

::v-deep .van-field__control::-webkit-input-placeholder {
  // color: #ffffff;
  font-size: 28px;
}
::v-deep .van-field__control{
  // color: #ffffff;
}
</style>
